import React, { useEffect } from 'react'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import { Container } from 'react-bootstrap'
import Col from 'react-bootstrap/Col'

function Checkbox(props){
    const disabled = props.disabled
    return(
        <Form>
            <Form.Group controlId="">
                <Form.Check type="checkbox" label={props.label} name={props.name} checked={props.data!=null?props.data[props.name]:null} disabled={disabled} onChange={props.onChange}/>
            </Form.Group>
        </Form>
    )
}
function MultiCheckbox(props){
    const title = props.title;
    const options = props.options;
    var disabled = props.disabled;
    // useEffect(()=>{
    // })
    const onChange  = (event)  =>{
        const {name, checked}  =event.target

    }
    return(
        <Form>
            <Form.Group controlId="">
                <Row>
                <Form.Label>{title}</Form.Label>
                </Row>
                {options.map((option,i)=>{
            
                    return(
                        <Form.Group>
                            <Form.Check key={i} type="checkbox" label={option[0]} name={option[1]}  checked={props.data!=null?props.data[option[1]]:null}onChange={props.onChange} disabled={disabled} />
                        </Form.Group>
                    )
                })}
            </Form.Group>
        </Form>
    )
}

MultiCheckbox.defaultProps = {
    disabled:false,
    data:null
}
Checkbox.defaultProps ={
    disabled:false,
    data:null
}

export {Checkbox,MultiCheckbox};
